import { useTranslations } from '@vocab/react';
import { Box, Heading, Stack, Text } from 'braid-design-system';

import { Empty } from './Empty';
import translations from './NoJobs.vocab';

interface NoJobsProps {
  type: string;
}

interface Content {
  heading: string;
  text: string;
}

type ContentMap = Record<string, Content>;

export const NoJobs = (props: NoJobsProps) => {
  const { type } = props;
  const { t } = useTranslations(translations);

  const content: ContentMap = {
    SAVED: {
      heading: t(`No saved jobs yet`),
      text: t(
        `Save jobs you’re interested in so you can come back to them later.`,
      ),
    },
    APPLIED: {
      heading: t(`No applications yet`),
      text: t(`Apply for jobs now and see your applications here.`),
    },
  };

  return (
    <Box
      textAlign="center"
      padding={{
        mobile: 'none',
        tablet: 'large',
        desktop: 'large',
        wide: 'large',
      }}
      marginTop="large"
      marginBottom="large"
    >
      <Stack space="large" align="center">
        <Empty />
        <Stack space="small">
          <Heading level="4">{content[type].heading}</Heading>
          <Text>{content[type].text}</Text>
        </Stack>
      </Stack>
    </Box>
  );
};
